import { FC } from "react";
import { useLanguage } from "../../context/LanguageContext";
import Memory from "../../assets/guru-guides-memory.png";
import Customise from "../../assets/guru-guides-customise.png";
import OutcomesImage from "../../assets/guru-outcomes-coming-soon.png";
import GuidesLogo from "../../assets/guides.svg";
import OutcomesLogo from "../../assets/outcomes.svg";
import { LinkCard } from "../../compositions/LinkCard";
import { PageHeading } from "../../compositions/PageHeading";
import styles from "./index.module.css";

const Content = () => {
  const { t } = useLanguage();
  return (
    <>
      <LinkCard
        title={t("guides.customise-page.title")}
        to="/guides/customise"
        description={t("guides.customise-page.description")}
        stretch
      >
        <mui-v-stack alignX="center" style={{ padding: "32px", paddingBottom: 0 }}>
          <img style={{ width: "100%", height: "auto" }} src={Customise} alt="customise" />
        </mui-v-stack>
      </LinkCard>

      <LinkCard
        title={t("guides.benefits-page.title")}
        to="/guides/benefits"
        description={t("guides.benefits-page.description")}
        stretch
      >
        <mui-v-stack
          alignX="center"
          style={{
            padding: "var(--space-300) var(--space-500)",
          }}
        >
          <img style={{ width: "100%", height: "auto" }} src={Memory} alt="memory" />
        </mui-v-stack>
      </LinkCard>
    </>
  );
};

export const Home: FC<{}> = () => {
  const { t } = useLanguage();
  return (
    <mui-v-stack class={styles.page}>
      {/* GUIDES SECTION */}
      <div style={{ maxWidth: 954, margin: "0 auto", width: "100%" }}>
        {/* HEADING */}
        <PageHeading page={t("guides.title")} logo={GuidesLogo} style={{ marginBottom: "var(--space-500)" }}>
          <mui-badge variant="positive">{t("figma-plugin.title")}</mui-badge>
        </PageHeading>

        <mui-responsive breakpoint="800">
          <mui-grid slot="showAbove" space="var(--space-800)" col="1fr 1fr">
            <Content />
          </mui-grid>
          <mui-v-stack slot="showBelow" space="var(--space-500)">
            <Content />
          </mui-v-stack>
        </mui-responsive>
      </div>

      {/* OUTCOMES SECTION */}
      <div style={{ maxWidth: 954, margin: "0 auto", width: "100%" }}>
        {/* HEADING */}
        <PageHeading page={t("outcomes.title")} logo={OutcomesLogo} style={{ marginBottom: "var(--space-500)" }}>
          <mui-h-stack space="var(--space-200)">
            <mui-badge variant="positive">{t("web-app.title")}</mui-badge>
            <mui-badge variant="neutral">{t("codex-plugin.title")}</mui-badge>
          </mui-h-stack>
        </PageHeading>

        <LinkCard title={t("outcomes.subtitle")} to="/outcomes" description={t("outcomes.description")}>
          <div style={{ borderBottomLeftRadius: 8, borderBottomRightRadius: 8, overflow: "hidden" }}>
            <img style={{ width: "100%", height: "auto" }} src={OutcomesImage} alt="setup" />
          </div>
        </LinkCard>
      </div>
    </mui-v-stack>
  );
};

export default Home;
